export const PHONE = {
    '+74992888087': '+7 (499) 288-80-87'
}